import { Component, OnInit } from '@angular/core';
import { ColDef, GridApi, GridReadyEvent, ICellRendererParams } from "ag-grid-community";
import { environment } from '../../../../../environments/environment';
import * as moment from 'moment';
import { FinancialsService } from 'src/app/services/modules/financials/financials.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-financial-report',
  templateUrl: './financial-report.component.html',
  styleUrls: ['./financial-report.component.scss']
})
export class FinancialReportComponent implements OnInit {

  private gridApi!: GridApi;
  currentMode: any;

  totalPaidAmount: number = 0;

  constructor(
    private financialsService: FinancialsService,
    private cookieService: CookieService
  ) {
    const isDev = window.location.hostname.includes('dev') || window.location.hostname.startsWith('localhost');
    // const cookieName = isDev ? 'Dev_TruckIt_Frontend_UserType' : 'TruckIt_Frontend_UserType';
    const cookieName = 'Truckit_user_type_prod';
    this.currentMode = this.cookieService.get(cookieName) as 'customer' | 'provider';

  }

  columnDefs: ColDef[] = [
    {
      headerName: '',
      checkboxSelection: true,
      headerCheckboxSelection: true,
      lockPosition: true,
      pinned: 'left',
      width: 50,
      resizable: false,
      sortable: false,
      suppressMenu: true,
      filter: false
    },
    {
      headerName: 'Date',
      field: 'created_at',
      filter: 'agDateColumnFilter',
      filterParams: {
        comparator: (filterLocalDateAtMidnight: Date, cellValue: string) => {
          const filterDateFormatted = moment(filterLocalDateAtMidnight).format('DD/MM/YYYY');

          const [day, month, year] = cellValue.split('/').map(Number);
          const cellDate = new Date(year, month - 1, day);

          if (cellDate < filterLocalDateAtMidnight) {
            return -1;
          } else if (cellDate > filterLocalDateAtMidnight) {
            return 1;
          } else {
            return 0;
          }
        },
        browserDatePicker: true,
      }
    },
    { headerName: 'Category', field: 'category_label', filter: 'agTextColumnFilter' },
    { headerName: 'Booking ID', field: 'booking_id', filter: 'agTextColumnFilter' },
    {
      headerName: 'Paid Amount',
      field: 'value',
      filter: 'agNumberColumnFilter',
      cellClass: 'ag-right-aligned-cell',
      valueFormatter: (params) => {
        // Check if the value is not null or undefined
        return params.value !== null && params.value !== undefined
          ? `$${params.value.toLocaleString()}`
          : '';
      },
    },
    { headerName: 'Status', field: 'status', filter: 'agTextColumnFilter' },
    { headerName: 'Payment Status', field: 'payment_status', filter: 'agTextColumnFilter' },
    {
      headerName: 'Download Invoice',
      field: 'invoice_url',
      filter: false,
      cellRenderer: (params: ICellRendererParams) => {
        if (params.data && params.data.booking_id) {
          const fullUrl = environment.appUrl + `/api/frontend/customer/customer-invoice?show=customer&booking_id=${params.data.booking_id}`;
          return `<a href="${fullUrl}" target="_blank">PDF</a>`;
        }
        return '';
      }
    }

  ];

  public defaultColDef: ColDef = {
    floatingFilter: true,
    filter: true,
    resizable: true,
  };

  public rowData: any[] = [] as any[];
  public rowSelection: 'multiple' | 'single' | undefined = 'multiple';

  ngOnInit() {
    this.loadData();
  }

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;

    this.gridApi.addEventListener('modelUpdated', () => {
      this.updateTotal();
    });
  }

  updateTotal() {
    let total = 0;

    // Iterate over all displayed rows
    this.gridApi.forEachNodeAfterFilterAndSort((rowNode) => {
      if (rowNode.data) {
        const amount = parseFloat(rowNode.data.value);
        total += isNaN(amount) ? 0 : amount;
      }
    });

    this.totalPaidAmount = total;
  }




  loadData() {

    // Choose function based on current mode
    const dataObservable = this.financialsService.getFinancialListing();

        console.log('dataObservable', this.currentMode);



    dataObservable.subscribe({
      next: (response: any) => {
        const apiResponse = response.data;

          this.rowData = apiResponse;

          this.totalPaidAmount = this.rowData.reduce((sum, row) => {
            const amount = parseFloat(row.value);
            return sum + (isNaN(amount) ? 0 : amount);
          }, 0);

          this.updateTotal();
      },
      error: (err) => {
        console.error('Error fetching data:', err);
      }
    });
  }

  exportFinancialCSV(){
    this.gridApi.exportDataAsExcel({
      allColumns: true,
      processCellCallback: (params: any) => {
        return params.value;
      }
    });
  }




}
